module.exports = require("next/document");


//////////////////
// WEBPACK FOOTER
// external "next/document"
// module id = next/document
// module chunks = 1